import React from 'react'
import { Box, Checkbox, FormControlLabel } from '@mui/material'
import {
  checkboxChecked,
  checkboxUnchecked,
  CheckBoxIcon,
  CheckBoxIcon2,
  CheckBoxIcon3,
  IconDefaultCheckbox,
  IconDefaultCheckboxChecked,
} from '../../assets/images/icons'
import MuiImage from '../muiImage'
import styled from '@emotion/styled'
import { CheckboxCheckedIconTheme2, CheckboxIconTheme2, FormGroupLabelWrap } from './style'
import { lightTheme } from '../../theme'

const MuiCheckbox = ({
  id,
  styling = '',
  indeterminate,
  className = '',
  color = 'default',
  variant = 'default',
  onChange = () => {},
  checked = false,
  label = '',
  size = 'medium',
  disabled = false,
  iconType = 'custom',
}) => {
  const renderIcons = (customIcon, customCheckedIcon) => {
    return iconType === 'default'
      ? {}
      : {
          icon: customIcon,
          checkedIcon: customCheckedIcon,
        }
  }

  return (
    <>
      {styling === 'default' ? (
        <FormGroupLabelWrap
          label={label}
          disabled={disabled}
          className={`formCheckbox ${variant === 'outlined' ? 'vOutlined' : ''} ${className}`}
          control={
            <Checkbox
              inputProps={{ id: id }}
              variant={variant}
              color={color}
              size={size}
              style={{
                color: `${lightTheme.palette[color]?.main ? lightTheme.palette[color]?.main : color}`,
              }}
              onChange={(e) => onChange({ id, checked: e.target.checked })}
              indeterminate={indeterminate}
              {...renderIcons(<CheckBoxIcon checked={false} />, <CheckBoxIcon />)}
              checked={checked}
            />
          }
        />
      ) : styling === 'filterSection' ? (
        <FormGroupLabelWrap
          label={label}
          disabled={disabled}
          className={`formCheckbox ${variant === 'outlined' ? 'vOutlined' : ''} ${className}`}
          control={
            <Checkbox
              variant={variant}
              color={color}
              onChange={onChange}
              indeterminate={indeterminate}
              size={size}
              style={{
                color: `${lightTheme.palette[color]?.main ? lightTheme.palette[color]?.main : color}`,
              }}
              checked={checked}
              {...renderIcons(
                <CheckBoxIcon2 variant='outlined' color={color} />,
                <CheckBoxIcon2 variant='contained' color={color} />
              )}
            />
          }
        />
      ) : styling === 'themeV2' ? (
        <FormGroupLabelWrap
          label={label}
          disabled={disabled}
          className={`formCheckbox themeV2 ${variant === 'outlined' ? 'vOutlined' : ''} ${className} ${size} ${label ? 'form-check-label-p' : ''}`}
          control={
            <Checkbox
              inputProps={{ id: id }}
              variant={variant}
              color={color}
              onChange={(e) => onChange({ id, checked: e.target.checked })}
              size={size}
              style={{
                color: `${lightTheme.palette[color]?.main ? lightTheme.palette[color]?.main : color}`,
              }}
              indeterminate={indeterminate}
              {...renderIcons(
                <CheckboxIconTheme2 />,
                <CheckboxCheckedIconTheme2>
                  <CheckBoxIcon3 />
                </CheckboxCheckedIconTheme2>
              )}
              checked={checked}
            />
          }
        />
      ) : (
        <FormGroupLabelWrap
          label={label}
          disabled={disabled}
          className={`formCheckbox ${variant === 'outlined' ? 'vOutlined' : 'vContained'} ${className}`}
          control={
            <Checkbox
              indeterminate={indeterminate}
              onChange={onChange}
              {...renderIcons(<IconDefaultCheckbox />, <IconDefaultCheckboxChecked />)}
              style={{
                color: `${lightTheme.palette[color]?.main ? lightTheme.palette[color]?.main : color}`,
              }}
              checked={checked}
              size={size}
              color={color}
              className={size}
            />
          }
        />
      )}
    </>
  )
}

export default MuiCheckbox
